module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-index"
  }, [_c('shop_header', {
    attrs: {
      "head-data": _vm.headData,
      "isHasShop": _vm.isHasShop
    },
    on: {
      "newKeyword": _vm.changeKeyword,
      "getShopListData": _vm.getShopListData,
      "applyHeadData": _vm.applyHeadData
    }
  }), _vm._v(" "), (!_vm.isHasShop) ? _c('div', {
    staticClass: "no-shop"
  }, [_vm._v("抱歉，暂无相关店铺!")]) : _vm._e(), _vm._v(" "), (_vm.isHasShop) ? _c('div', {
    staticClass: "shop-nav"
  }, [_c('ul', {
    staticClass: "pngFix"
  }, _vm._l((_vm.navList), function(row, index) {
    return _c('li', {
      key: index,
      class: {
        'active': index == _vm.tab - 1
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.changeTab(row.tab)
        }
      }
    }, [_vm._v("\n          " + _vm._s(row.name) + "\n        ")])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.tab == '1' && _vm.isHasShop) ? _c('div', {
    staticClass: "pb20"
  }, [_c('div', {
    staticClass: "swipe-wrap",
    attrs: {
      "id": "shopswiper"
    }
  }, [(_vm.sildeList.length) ? _c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.shopBanner),
      callback: function($$v) {
        _vm.shopBanner = $$v
      },
      expression: "shopBanner"
    }
  }, _vm._l((_vm.sildeList), function(row, index) {
    return _c('CarouselItem', {
      key: index
    }, [_c('div', {
      staticClass: "demo-carousel",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.gotoTarget(row)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": row.img,
        "height": "480",
        "width": "1000"
      }
    })])])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.specialRecommendGoods.length > 0) ? _c('div', {
    staticClass: "shop-item"
  }, [_c('div', {
    staticClass: "title mt20"
  }, [_c('span', [_c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.changeTab(2, 8)
      }
    }
  }, [_vm._v("更多>>")])]), _vm._v(" "), _c('h4', [_vm._v("特别推荐商品")])]), _vm._v(" "), _c('div', {
    staticClass: "shop-hot-list"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.specialRecommendGoods), function(row) {
    return _c('li', [_c('dl', [_c('dd', {
      staticClass: "ncg-pic pngFix"
    }, [_c('router-link', {
      staticClass: "thumb",
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        }
      }
    }, [_c('i'), _vm._v(" "), _c('img', {
      attrs: {
        "src": row.thumbnail,
        "height": "195",
        "width": "195"
      }
    })])], 1), _vm._v(" "), _c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.name
      }
    }, [_vm._v("\n                    " + _vm._s(row.name) + "\n                  ")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "ncg-price"
    }, [_c('em', {
      staticClass: "price"
    }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(row.price))])]), _vm._v(" "), _c('dd', {
      staticClass: "ncg-sold"
    }, [_vm._v("\n                  已销售："), _c('strong', [_vm._v(_vm._s(row.buyNum))]), _vm._v(" 件\n                ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.hotSellGoods.length > 0) ? _c('div', {
    staticClass: "shop-item"
  }, [_c('div', {
    staticClass: "title mt20"
  }, [_c('span', [_c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.changeTab(2, 9)
      }
    }
  }, [_vm._v("更多>>")])]), _vm._v(" "), _c('h4', [_vm._v("热销商品排行")])]), _vm._v(" "), _c('div', {
    staticClass: "shop-com-list"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.hotSellGoods), function(row) {
    return _c('li', [_c('dl', [_c('dd', {
      staticClass: "ncg-pic pngFix"
    }, [_c('router-link', {
      staticClass: "thumb",
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        }
      }
    }, [_c('i'), _vm._v(" "), _c('img', {
      attrs: {
        "src": row.thumbnail,
        "height": "160",
        "width": "160"
      }
    })])], 1), _vm._v(" "), _c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.name
      }
    }, [_vm._v("\n                    " + _vm._s(row.name) + "\n                  ")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "ncg-price"
    }, [_c('em', {
      staticClass: "price"
    }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(row.price))])]), _vm._v(" "), _c('dd', {
      staticClass: "ncg-sold"
    }, [_vm._v("\n                  已销售："), _c('strong', [_vm._v(_vm._s(row.buyNum))]), _vm._v(" 件\n                ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.newGoods.length > 0) ? _c('div', {
    staticClass: "shop-item"
  }, [_c('div', {
    staticClass: "title mt20"
  }, [_c('span', [_c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.changeTab(2, 10)
      }
    }
  }, [_vm._v("更多>>")])]), _vm._v(" "), _c('h4', [_vm._v("新品")])]), _vm._v(" "), _c('div', {
    staticClass: "shop-new-list"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.newGoods), function(row) {
    return _c('li', [_c('dl', [_c('dd', {
      staticClass: "ncg-pic pngFix"
    }, [_c('router-link', {
      staticClass: "thumb",
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        }
      }
    }, [_c('i'), _vm._v(" "), _c('img', {
      attrs: {
        "src": row.thumbnail,
        "height": "200",
        "width": "200"
      }
    })])], 1), _vm._v(" "), _c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.name
      }
    }, [_vm._v("\n                    " + _vm._s(row.name) + "\n                  ")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "ncg-price"
    }, [_c('em', {
      staticClass: "price"
    }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(row.price))])]), _vm._v(" "), _c('dd', {
      staticClass: "ncg-sold"
    }, [_vm._v("\n                  已销售："), _c('strong', [_vm._v(_vm._s(row.buyNum))]), _vm._v(" 件\n                ")])])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.recommendGoods.length > 0) ? _c('div', {
    staticClass: "shop-item"
  }, [_c('div', {
    staticClass: "title mt20"
  }, [_c('span', [_c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.changeTab(2, 11)
      }
    }
  }, [_vm._v("更多>>")])]), _vm._v(" "), _c('h4', [_vm._v("推荐商品")])]), _vm._v(" "), _c('div', {
    staticClass: "shop-com-list"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.recommendGoods), function(row) {
    return _c('li', [_c('dl', [_c('dd', {
      staticClass: "ncg-pic pngFix"
    }, [_c('router-link', {
      staticClass: "thumb",
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        }
      }
    }, [_c('i'), _vm._v(" "), _c('img', {
      attrs: {
        "src": row.thumbnail,
        "height": "160",
        "width": "160"
      }
    })])], 1), _vm._v(" "), _c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.name
      }
    }, [_vm._v("\n                    " + _vm._s(row.name) + "\n                  ")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "ncg-price"
    }, [_c('em', {
      staticClass: "price"
    }, [_c('i', [_vm._v("¥")]), _vm._v(_vm._s(row.price))])]), _vm._v(" "), _c('dd', {
      staticClass: "ncg-sold"
    }, [_vm._v("\n                  已销售："), _c('strong', [_vm._v(_vm._s(row.buyNum))]), _vm._v(" 件\n                ")])])])
  }), 0)])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.tab == '2' && _vm.isHasShop) ? _c('div', {
    staticClass: "nc-goods-main shop-container"
  }, [_c('div', {
    staticClass: "left-card mt10"
  }, [_c('div', {
    staticClass: "classify card"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商品分类")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.catListData), function(item) {
    return _c('div', [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.toggle(item)
        }
      }
    }, [_c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }]
    }, [_vm._v("-")]), _c('em', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.show),
        expression: "!item.show"
      }]
    }, [_vm._v("+")])]), _vm._v(" "), _c('a', {
      class: {
        'active': _vm.priceFormData.acid == item.storeCatId && _vm.priceFormData.pid == ''
      },
      attrs: {
        "title": item.storeCatName
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.setNavigationTag(item)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("limitToNum")(item.storeCatName, 10)))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }]
    }, _vm._l((item.list), function(item) {
      return _c('a', {
        class: {
          'active': _vm.priceFormData.acid == item.storeCatId && _vm.priceFormData.pid == item.storeCatPid
        },
        staticStyle: {
          "display": "block",
          "padding-left": "26px",
          "font-weight": "normal"
        },
        attrs: {
          "title": item.storeCatName
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.setNavigationTag(item)
          }
        }
      }, [_vm._v("\n                • " + _vm._s(_vm._f("limitToNum")(item.storeCatName, 10)) + "\n              ")])
    }), 0)])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "nc-s-c-s3 ncg-list mt10"
  }, [_c('div', {
    staticClass: "ncs-goodslist-bar"
  }, [_c('ul', {
    staticClass: "ncs-array"
  }, _vm._l((_vm.setFormData), function(row, index) {
    return _c('li', {
      class: {
        'active': index == _vm.priceFormData.key - 1,
        'desc': index == _vm.priceFormData.key - 1 && _vm.priceFormData.order == 'asc',
        'asc': index == _vm.priceFormData.key - 1 && _vm.priceFormData.order == 'desc'
      },
      on: {
        "click": function($event) {
          return _vm.setForm(row.key)
        }
      }
    }, [_c('a', {
      staticClass: "sort-indicator"
    }, [_vm._v(_vm._s(row.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "price-search"
  }, [_c('em', [_vm._v("￥")]), _vm._v(" \n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceFormData.start_price),
      expression: "priceFormData.start_price"
    }],
    staticClass: "w30",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.priceFormData.start_price)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.priceFormData, "start_price", $event.target.value)
      }, _vm.handleInput]
    }
  }), _c('i', [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceFormData.end_price),
      expression: "priceFormData.end_price"
    }],
    staticClass: "w30",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.priceFormData.end_price)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.priceFormData, "end_price", $event.target.value)
      }, _vm.handleInput]
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.priceSearch()
      }
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "squares",
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "nc_type": "current_display_mode"
    }
  }, [(_vm.shopList.length === 0) ? _c('div', {
    attrs: {
      "nc_type": "current_display_mode"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "20px"
    }
  }, [_vm._v("抱歉,暂无此类商品!")])]) : _c('ul', _vm._l((_vm.shopList), function(row) {
    return _c('li', [_c('dl', [_c('dt', [_c('router-link', {
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.name
      }
    }, [_vm._v("\n                    " + _vm._s(row.name) + "\n                  ")])], 1), _vm._v(" "), _c('dd', {
      staticClass: "ncg-pic pngFix"
    }, [_c('router-link', {
      staticClass: "thumb size160",
      attrs: {
        "to": {
          path: 'goods',
          query: {
            goods_id: row.goodsId
          }
        },
        "title": row.name
      }
    }, [_c('i'), _vm._v(" "), _c('img', {
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "src": row.thumbnail,
        "title": row.name,
        "height": "160",
        "width": "160"
      }
    })])], 1), _vm._v(" "), _c('dd', {
      staticClass: "ncg-price"
    }, [_c('em', {
      staticClass: "price"
    }, [_vm._v("￥" + _vm._s(row.price))])]), _vm._v(" "), _c('dd', {
      staticClass: "ncg-sold"
    }, [_vm._v("\n                  售出："), _c('strong', [_vm._v(_vm._s(row.buyNum))]), _vm._v(" 件\n                ")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "pb20 floatr"
  }, [_c('Page', {
    ref: "pages",
    attrs: {
      "total": _vm.dataTotal,
      "page-size": _vm.pageSize,
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.changepage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.tab == '3' && _vm.isHasShop) ? _c('div', {
    staticClass: "shop-container"
  }, [_c('div', {
    staticClass: "nc-s-c-s3 ncs-comment mt10"
  }, [_c('div', {
    staticClass: "personal-rating"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "seller-rate-info mt20",
    attrs: {
      "id": "sixmonth"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_c('p', [_vm._v("宝贝与描述相符")]), _vm._v(" "), _c('p', {
    staticClass: "rate-star mt5"
  }, [_c('em', [_c('i', {
    style: ({
      width: _vm.shopCredit.storeDesccredit / 5 * 100 + '%'
    })
  })])])]), _vm._v(" "), _c('td', [_c('dl', {
    staticClass: "ncs-rate-column"
  }, [_c('dt', [_c('em', {
    style: ({
      left: _vm.shopCredit.storeDesccredit / 5 * 100 + '%'
    })
  }, [_vm._v(_vm._s(_vm.shopCredit.storeDesccredit))])]), _vm._v(" "), _vm._l((_vm.containerData), function(row) {
    return _c('dd', [_vm._v(_vm._s(row.name))])
  })], 2)])]), _vm._v(" "), _c('tr', [_c('th', [_c('p', [_vm._v("卖家的服务态度")]), _vm._v(" "), _c('p', {
    staticClass: "rate-star mt5"
  }, [_c('em', [_c('i', {
    style: ({
      width: _vm.shopCredit.storeServicecredit / 5 * 100 + '%'
    })
  })])])]), _vm._v(" "), _c('td', [_c('dl', {
    staticClass: "ncs-rate-column"
  }, [_c('dt', [_c('em', {
    style: ({
      left: _vm.shopCredit.storeServicecredit / 5 * 100 + '%'
    })
  }, [_vm._v(_vm._s(_vm.shopCredit.storeServicecredit))])]), _vm._v(" "), _vm._l((_vm.containerData), function(row) {
    return _c('dd', [_vm._v(_vm._s(row.name))])
  })], 2)])]), _vm._v(" "), _c('tr', [_c('th', [_c('p', [_vm._v("卖家的发货速度")]), _vm._v(" "), _c('p', {
    staticClass: "rate-star mt5"
  }, [_c('em', [_c('i', {
    style: ({
      width: _vm.shopCredit.storeDeliverycredit / 5 * 100 + '%'
    })
  })])])]), _vm._v(" "), _c('td', [_c('dl', {
    staticClass: "ncs-rate-column"
  }, [_c('dt', [_c('em', {
    style: ({
      left: _vm.shopCredit.storeDeliverycredit / 5 * 100 + '%'
    })
  }, [_vm._v(_vm._s(_vm.shopCredit.storeDeliverycredit))])]), _vm._v(" "), _vm._l((_vm.containerData), function(row) {
    return _c('dd', [_vm._v(_vm._s(row.name))])
  })], 2)])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.tab == '4' && _vm.isHasShop) ? _c('div', {
    staticClass: "shop-container"
  }, [_c('section', {
    staticClass: "layout"
  }, [_c('article', {
    staticClass: "nc-goods-main"
  }, [_c('div', {
    staticClass: "nc-s-c-s3 mt10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content pt10 pb20 clearfix"
  }, [_c('div', {
    staticClass: "ncs-info clearfix"
  }, [_c('div', {
    staticClass: "shop-card"
  }, [_c('h4', [_vm._v("店铺")]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "thumb size60"
  }, [_c('i'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#4"
    }
  }, [_c('img', {
    staticClass: "pngFix",
    attrs: {
      "src": _vm.shopInfoData.storeLogo,
      "title": _vm.shopInfoData.storeName,
      "height": "50px",
      "width": "50px"
    }
  })])])]), _vm._v(" "), _c('dd', [_vm._v("\n                    " + _vm._s(_vm.shopInfoData.storeName) + "\n                  ")]), _vm._v(" "), _c('dd', {
    staticClass: "ncs-level"
  }, [_vm._v("卖家信用：" + _vm._s(_vm.shopInfoData.storeCredit))]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("好评率：")]), _vm._v(_vm._s(_vm.shopInfoData.praiseRate) + "%\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-rate"
  }, [_c('h4', [_vm._v("动态评价")]), _vm._v(" "), _c('dl', {
    staticClass: "rate"
  }, [_c('dt', [_vm._v("描述相符：")]), _vm._v(" "), _c('dd', {
    staticClass: "rate-star evaluate"
  }, [_c('em', [_c('i', {
    style: ({
      width: _vm.shopCredit.storeDesccredit / 5 * 100 + '%'
    })
  })])]), _vm._v(" "), _c('dt', [_vm._v("服务态度：")]), _vm._v(" "), _c('dd', {
    staticClass: "rate-star evaluate"
  }, [_c('em', [_c('i', {
    style: ({
      width: _vm.shopCredit.storeDervicecredit / 5 * 100 + '%'
    })
  })])]), _vm._v(" "), _c('dt', [_vm._v("发货速度：")]), _vm._v(" "), _c('dd', {
    staticClass: "rate-star evaluate"
  }, [_c('em', [_c('i', {
    style: ({
      width: _vm.shopCredit.storeDeliverycredit / 5 * 100 + '%'
    })
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-detail"
  }, [_c('h4', [_vm._v("店铺信息")]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("创店时间：")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.shopInfoData.passTime))]), _vm._v(" "), _c('dt', [_vm._v("所 在 地：")]), _vm._v(" "), _c('dd', [_vm._v("\n                    " + _vm._s(_vm.shopInfoData.storeProvince) + " " + _vm._s(_vm.shopInfoData.storeCity) + " " + _vm._s(_vm.shopInfoData.storeRegion) + " " + _vm._s(_vm.shopInfoData.storeVillages) + "\n                  ")]), _vm._v(" "), _c('dt', [_vm._v("商品数量：")]), _vm._v(" "), _c('dd', [_c('strong', [_vm._v(_vm._s(_vm.shopInfoData.normalGoodsNum))]), _vm._v("件商品\n                  ")]), _vm._v(" "), _c('dt', [_vm._v("店铺收藏：")]), _vm._v(" "), _c('dd', [_c('strong', {
    attrs: {
      "nctype": "store_collect"
    }
  }, [_vm._v(_vm._s(_vm.shopInfoData.storeCollect))]), _vm._v("人收藏\n                  ")]), _vm._v(" "), _c('dt', [_vm._v("认证信息：")]), _vm._v(" "), _c('dd', [(_vm.shopInfoData.storeAuth == 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_autonym.gif",
      "title": "身份已认证",
      "alt": "身份已认证"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopInfoData.storeAuth == 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_material.gif",
      "title": "店铺已认证",
      "alt": "店铺已认证"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopInfoData.storeAuth != 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_autonym_no.gif",
      "title": "身份未认证或认证失败",
      "alt": "身份未认证或认证失败"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopInfoData.storeAuth != 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_material_no.gif",
      "title": "尚未认证或认证失败",
      "alt": "尚未认证或认证失败"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-im"
  }, [_c('h4', [_vm._v("联系方式")]), _vm._v(" "), _c('p', [_vm._v("联系电话：" + _vm._s(_vm.shopInfoData.tel))])]), _vm._v(" "), (_vm.shopInfoData.licenseImg) ? _c('div', {
    staticClass: "shop-im"
  }, [_c('h4', [_vm._v("营业执照")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.shopInfoData.licenseImg,
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "src": _vm.shopInfoData.licenseImg,
      "title": "营业执照",
      "alt": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ncu-intro"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "content clearfix"
  }, [_c('h2', {
    staticClass: "ncu-name"
  }, [_vm._v(_vm._s(_vm.headData.storeName))]), _vm._v(" "), _c('dl', {
    staticClass: "ncu-shop-info"
  }, [_c('dt', [_c('span', {
    staticClass: "thumb size80"
  }, [_c('i'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.shopInfoData.storeLogo,
      "id": "logo",
      "height": "80",
      "width": "80"
    }
  })])])]), _vm._v(" "), _c('dd', {
    staticClass: "base"
  }, [_c('p', [_vm._v("店铺名称：" + _vm._s(_vm.shopInfoData.storeName))]), _vm._v(" "), _c('p', [_vm._v("店铺等级：" + _vm._s(_vm.membershipLevelName))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "fl"
  }, [_vm._v("认证信息：")]), _vm._v(" "), (_vm.shopInfoData.storeAuth == 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_autonym.gif",
      "title": "身份已认证",
      "alt": "身份已认证"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopInfoData.storeAuth == 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_material.gif",
      "title": "店铺已认证",
      "alt": "店铺已认证"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopInfoData.storeAuth != 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_autonym_no.gif",
      "title": "身份未认证或认证失败",
      "alt": "身份未认证或认证失败"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shopInfoData.storeAuth != 1) ? _c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/cert_material_no.gif",
      "title": "尚未认证或认证失败",
      "alt": "尚未认证或认证失败"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('dl', {
    staticClass: "nus-basic-info"
  }, [_c('dt', [_vm._v("基本信息")]), _vm._v(" "), _c('dd', [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("卖家信用：")]), _vm._v(" " + _vm._s(_vm.shopInfoData.storeCredit) + "\n                  ")]), _vm._v(" "), _c('dd', [_vm._v("注册时间：" + _vm._s(_vm.shopInfoData.passTime))])]), _vm._v(" "), _c('dl', {
    staticClass: "nus-contact",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('dt', [_vm._v("联系方式")]), _vm._v(" "), _c('dd', [_vm._v("\n                    所 在 地：" + _vm._s(_vm.shopInfoData.storeProvince) + " " + _vm._s(_vm.shopInfoData.storeCity) + " " + _vm._s(_vm.shopInfoData.storeRegion) + " " + _vm._s(_vm.shopInfoData.storeVillages) + "\n                  ")]), _vm._v(" "), _c('dd', [_vm._v("详细地址：" + _vm._s(_vm.shopInfoData.attr))]), _vm._v(" "), _c('dd', [_vm._v("联系电话：" + _vm._s(_vm.shopInfoData.tel))]), _vm._v(" "), _c('dd', [_c('span', [_vm._v("店铺简介：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "0px",
      "margin": "0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.shopInfoData.description)
    }
  })])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.shopInfoData.storeBanner,
      "id": "img_store_banner",
      "height": "158",
      "width": "610"
    }
  })])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.tab == '5' && _vm.isHasShop) ? _c('div', {
    staticClass: "shop-container flexslider"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": 'outside',
      "radius-dot": true,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow
    },
    model: {
      value: (_vm.entityPicture),
      callback: function($$v) {
        _vm.entityPicture = $$v
      },
      expression: "entityPicture"
    }
  }, _vm._l((_vm.shopImgsList), function(row, index) {
    return _c('CarouselItem', {
      key: index
    }, [_c('div', {
      staticClass: "demo-carousel"
    }, [_c('img', {
      attrs: {
        "src": row.storeImgsUrl,
        "height": "444",
        "width": "790"
      }
    })])])
  }), 1)], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("店铺动态评分")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("店铺详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-542daa3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/shop-detail.vue
// module id = 1605
// module chunks = 1